import { render, staticRenderFns } from "./ConveniosFormulario.vue?vue&type=template&id=4b1f50ae&"
import script from "./ConveniosFormulario.vue?vue&type=script&lang=ts&"
export * from "./ConveniosFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports